import { render, staticRenderFns } from "./ButtonSPID.vue?vue&type=template&id=6e5dc4a2&scoped=true"
import script from "./ButtonSPID.vue?vue&type=script&lang=js"
export * from "./ButtonSPID.vue?vue&type=script&lang=js"
import style0 from "./ButtonSPID.vue?vue&type=style&index=0&id=6e5dc4a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5dc4a2",
  null
  
)

export default component.exports